import React from 'react'
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela'
import CelulaHeader from '../../Common/CelulaHeader'
import Celula from '../../Common/Celula'
import {mascCPF, mascCNPJ} from '../../Helpers/mascara'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import {get} from 'lodash-es'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const TabelaLinha = styled(TL)`
  grid-template-columns: 20px 40px 170px 390px 120px 122px;
`
const TextField_ = styled(TextField)`
  margin: 5px;
`
const Button_ = styled(Button)`
  margin-left: 5px;
`

const GrupoEmpresasEditUI = props => {
  const {form,sort,lista,dialog,title,buttons} = props;
  const {open,closeDialog} = dialog;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={closeDialog}
      TransitionComponent={Transition}
    >
      <AppBar>
        <Toolbar>
          <Typography variant="title" color="inherit" style={{flexGrow:1}}>
            {title}
          </Typography>
          {buttons.map(btn => (
            <Button_ 
              variant="contained"
              color={get(btn,"color")}
              disabled={btn.disabled && btn.disabled()}
              onClick={btn.onClick}
            >
              {btn.label}
            </Button_>
          ))
          }
          <IconButton color="inherit" onClick={dialog.closeDialog} aria-label="Close" style={{marginLeft: "10px"}}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div style={{marginTop:"80px"}}></div>
      <GrupoEmpresasEditUIContent
        dialog={dialog.open}
        lista={lista}
        form={form}
        sort={{
          ...sort,
          set: sort.setSort,
        }}
      />
    </Dialog>
  )
}

const format = s => {
  if (!s) return ""
  if (s.length === 14) return mascCNPJ(s)
  if (s.length === 11) return mascCPF(s)
  return s
}

const GrupoEmpresasEditUIContent = props => {
  const { lista, sort, form } = props;
  const { values, set } = form;
  const { Cod, Nome, Membros } = values;
  const fields = [
    ["Codigo", "Cod"],
    ["Apelido", "Apelido"],
    ["RazaoSocial", "Razão Social"],
    ["Cidade", "Cidade"],
    ["CNPJ", "CNPJ/CPF", format],
  ]
  return (
    <div style={{display:"flex", alignItems: "center", flexDirection: "column"}}>
    <div>
    <TextField_
      id="codMembros"
      label="Código"
      value={Cod}
      onChange={e => set("Cod")(e.target.value)}
      margin="normal"
    />
    <TextField_
      id="nomeGrupo"
      label="Nome do Grupo"
      value={Nome}
      onChange={e => set("Nome")(e.target.value)}
      margin="normal"
    />
    </div>
    <div style={{
      marginTop: "10px",
      marginBottom: "10px"
    }}>
      Vincular empresas ao grupo:
    </div>
    <Tabela cursor="pointer">
      <TabelaLinha header >
        <CelulaHeader key={"aa"} field={["",""]} sort={""}/>
        {fields.map((f,i) => (
          <CelulaHeader key={"a"+i} field={f} sort={sort}/>
        ))}
      </TabelaLinha>
      {lista.map((empr,i0) => {
        let sel = Membros.includes(empr.Codigo)
        return (
          <TabelaLinha
            key={"b"+i0}
            onClick={() => {
              if (sel) {
                set("Membros")(grupo => grupo.filter(e=>e!==empr.Codigo))
              } else {
                set("Membros")(grupo => ([...grupo, empr.Codigo ]))
              }
            }}
            color={sel ? "#009900" : null}
          >
            <Celula key={"c"+i0}>{sel ? "\u2714" : ""}</Celula>
            {fields.map((f,i1) => (<Celula key={"c"+i0+i1}>{f[2] ? f[2](empr[f[0]]) : empr[f[0]]}</Celula>))}
          </TabelaLinha>
        )})}
    </Tabela>
    </div>
  )
}

export default GrupoEmpresasEditUI
